import { useSelector } from "react-redux";

// Components
import WelcomeBonusInfo from "components/molecules/WelcomeBonusInfo";

// Constants
import { GET_POPUP_TYPES } from "constants/popupConfig";

// Hooks
import { useGTM } from "hooks/useGTM";

// Selectors
import * as authSelectors from "redux/auth/selectors";
import * as userSelectors from "redux/user/selectors";
import { useTogglePopup } from "hooks/useTogglePopup";

const WelcomeBonusInfoContainer = () => {
  const { isAuthenticated } = useSelector(authSelectors.all);
  const user = useSelector(userSelectors.all);
  const GTM = useGTM();

  const { openPopup } = useTogglePopup();

  const onClickHandler = () => {
    GTM.clickGetWelcomeBonusAccept();
    GTM.openDeposit();
    if (isAuthenticated) {
      openPopup(GET_POPUP_TYPES.popup.deposit);
    } else {
      openPopup(GET_POPUP_TYPES.popup.signUp);
    }
  };

  // eslint-disable-next-line react/jsx-handler-names
  return <WelcomeBonusInfo user={user} onClick={onClickHandler} />;
};

export default WelcomeBonusInfoContainer;
